module.exports = __webpack_public_path__ + "img/signature-white.fdf66eab.png";